$(function(){
	var wrapperEls = $('.form-photos');

	wrapperEls.on('click', '.form-photos__delete', function(){
		var thisEl = $(this);

		// remove image from preview
		thisEl.closest('.form-photos__item').removeAttr('data-upload-image').attr('data-delete-image', true).hide();
	});
});